module.exports = __webpack_public_path__ + "components/country-flag/static/al-7d5b8edcdcb7b98a8ec4db76132716db.svg";